import { CloseCircleOutlined } from '@ant-design/icons'
import React, { useCallback, useState } from 'react'
import { BlacklistDiv, IconWrapper } from './style'
const BlacklistMessageComponent = ({
  studentDetails,
  optOutStatus,
  onAction,
}) => {
  const [visible, setVisible] = useState(true)
  const isOptOut = optOutStatus?.optoutStatus?.currentCourse?.optOutStatus
  const isBlacklisted = studentDetails?.status === -1
  const rejected =
    optOutStatus?.optoutStatus?.currentCourse?.optoutApproveStatus
  const RejectedStatus =
    optOutStatus?.optOutStatus?.currentCourse?.optedStatusText
  const newStatus = RejectedStatus === 'Opted In' ? 'opt-in' : 'opt-out'

  const blacklistReasons = [
    studentDetails?.currentCourse?.collegeFeeBacklisted &&
      'non-payment of the required fee',
    studentDetails?.currentCourse?.conductBacklisted && 'bad conduct',
    studentDetails?.currentCourse?.attendanceBacklisted && 'low attendance',
  ]
    .filter(Boolean)
    .reduce((acc, reason, index, array) => {
      if (index === 0) return reason
      if (index === array.length - 1 && index === 1)
        return `${acc} and ${reason}`
      if (index === array.length - 1) return `${acc}, and ${reason}`
      return `${acc}, ${reason}`
    }, '')

  const messageConfigs = [
    {
      condition: isBlacklisted && isOptOut == 1,
      message:
        'You are blacklisted and your opt-out status requires further action.',
    },
    {
      condition: isOptOut == 1 && rejected === false,
      message: `you are opt-out from placement process and your request for opt-in was rejected.`,
      action: true,
    },
    {
      condition: isOptOut == 1 || isOptOut == 4,
      message: 'you are opt-out from placement process.',
    },

    {
      condition: rejected === false || RejectedStatus,
      message: `Your request for ${newStatus} was rejected.`,
      action: true,
    },
    {
      condition: rejected === false && isBlacklisted,
      message: 'Your application has been rejected by Tpo and blackListed',
      action: true,
    },
    {
      condition: isBlacklisted,
      message: `Please note: You are blacklisted due to ${blacklistReasons}.`,
    },
  ]

  const selectedConfig = messageConfigs.find(config => config.condition)
  const handleActionClick = useCallback(async () => {
    try {
      const payload = {
        view: true,
      }
      await onAction?.(payload)

      setVisible(false)
    } catch (err) {
      console.log(err)
    }
  }, [onAction])
  return (
    visible &&
    selectedConfig?.message && (
      <BlacklistDiv>
        <span>
          {selectedConfig.message} <span>Please contact your TPO.</span>
        </span>
        {selectedConfig.action && (
          <IconWrapper onClick={handleActionClick}>
            <CloseCircleOutlined />
          </IconWrapper>
        )}
      </BlacklistDiv>
    )
  )
}

export default BlacklistMessageComponent
